export default "__VITE_ASSET__53c82f09__"